module.exports = __webpack_public_path__ + "img/best_4.49816ac4.svg";